document.addEventListener("DOMContentLoaded", function() {

  // TODO This is also used on product page - it needs to be shared between them
  const specificDisabledDates = [
    '2024-12-24','2024-12-25','2024-12-26','2024-12-27','2025-01-01','2025-01-02','2025-04-17','2025-04-18','2025-04-19','2025-04-20'
  ];

  const anyDeliveryDatesInvalid = () => {
    const deliveryDateElements = document.querySelectorAll("[data-delivery-date]");
    return Array.from(deliveryDateElements).some(element => {
      const deliveryDateStr =  element.getAttribute("data-delivery-date");
      const [day, month, year] = deliveryDateStr.split("-");
      const deliveryDate = new Date(year, month - 1, day);
      if( !isValidDeliveryDate(deliveryDate) ) return true;
    });
    return false;
  }

  const isValidDeliveryDate = (date) => {
    const now = new Date();
    const today = new Date();
    if( date <= today) {
      return false;
    }

    // Earliest delivery date is tomorrow if before 4PM
    const ukToday = new Date(now.toLocaleString("en-US", { timeZone: "Europe/London" }));
    ukToday.setHours(16, 0, 0, 0);
    const isBefore4PMUK = now < ukToday;
    if(!isBefore4PMUK){
      var tomorrowUK = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/London" }));
      tomorrowUK.setDate(tomorrowUK.getDate() + 1);
      if (
        date.getFullYear() === tomorrowUK.getFullYear() &&
          date.getMonth() === tomorrowUK.getMonth() &&
          date.getDate() === tomorrowUK.getDate()
      ) {
        return false;
      }
    }
    const formattedDate = date.toISOString().split('T')[0];
    if (specificDisabledDates.includes(formattedDate)) {
      return false;
    }
    return true;
  }

  const checkoutButton = document.querySelector(".btn-cart-checkout");
  if (checkoutButton) {
    console.log("Checkout button found!");
    
    if(anyDeliveryDatesInvalid()){
      console.log("there are two many delivery dates");

      // Disable the checkout button
      checkoutButton.disabled = true;

      // Show warnings by removing the 'hidden' class on elements with the data-delivery-date-warning attribute
      const warningElements = document.querySelectorAll("[data-delivery-date-warning]");
      warningElements.forEach(element => element.classList.remove("hidden"));

      // Add any action you'd like to perform here
      checkoutButton.addEventListener("click", function(event) {
        event.preventDefault();
        return false;
      });
      
    }
  } else {
    console.log("Checkout button not found.");
  }
  




  // Reveal warnings about invalid delivery dates (if relevant)
  const deliveryDateElements = document.querySelectorAll("[data-delivery-date]");
  deliveryDateElements.forEach(element => {
    const deliveryDateStr =  element.getAttribute("data-delivery-date");
    const [day, month, year] = deliveryDateStr.split("-");
    const deliveryDate = new Date(year, month - 1, day);

    if( !isValidDeliveryDate(deliveryDate) ){
      element.classList.remove("hidden");
    }
  });




  // Listen for the cart model window
  const modalContainer = document.querySelector('#MainContent'); 
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check if the new node includes the link with the specified class
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('mini-cart-item')) {
            const cartButtonCheckoutElements = document.querySelectorAll(".js-cart-btn-checkout");
            console.log(cartButtonCheckoutElements);

            // Add any event listener or action you want to take with the new link
            // node.addEventListener('click', (event) => {
            //   event.preventDefault();
            //   console.log("Checkout button clicked!");
            // });
          }
        });
      }
    }
  });
  const config = { childList: true, subtree: true };
  if (modalContainer) {
    observer.observe(modalContainer, config);
  } else {
    console.log("Modal container not found.");
  }

  
});
